<template>
  <form @submit="onSubmit">
    <BaseCard
      class="relative mx-auto w-full max-w-sm overflow-hidden"
    >
      <div class="space-y-6">
        <FormInputSelect
          name="schemaName"
          label="Merchant"
          :options="merchantOptions"
          disable-null
        />
        <FormInputText name="email" label="Email" />
        <FormInputText
          name="firstName"
          label="First Name"
        />
        <FormInputText name="lastName" label="Last Name" />
        <FormSubmitButton
          :is-submitting="isSubmitting"
          class="w-full"
        >
          Create User
        </FormSubmitButton>
      </div>
    </BaseCard>
  </form>
</template>

<script setup lang="ts">
import { ApiError } from "@/api"

const router = useRouter()

const { handleSubmit, setErrors, isSubmitting } =
  useCreateMerchantGroupUserForm()

const onSubmit = handleSubmit(async (formValues) => {
  try {
    await createMerchantGroupUser(formValues)
    toast.success("User created")
    router.push({ name: "merchantGroupUsersIndex" })
  } catch (error) {
    if (error instanceof ApiError) {
      setErrors(error.requestErrors?.body ?? {})
    }
    toast.error("Failed to create user")
    throw error
  }
})

const { data: merchantResp } = useMerchantGroupMerchants()

const merchantOptions = computed(
  () =>
    merchantResp.value?.merchants.map((m) => ({
      value: m.schemaName,
      label: m.merchantName,
    })) ?? []
)
</script>
